import { render, staticRenderFns } from "./WorkDateField.vue?vue&type=template&id=52694423"
import script from "./WorkDateField.vue?vue&type=script&lang=js"
export * from "./WorkDateField.vue?vue&type=script&lang=js"
import style0 from "./WorkDateField.vue?vue&type=style&index=0&id=52694423&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports